/**
 * Frames captured from iOS cameras are always in landscape-primary mode, and they need
 * to be rotated clockwise by the following angles (depending on the actual source
 * device orientation type) to display them upright.
 */
export const orientationTypeToRotationMap = {
    'landscape-primary': 0,
    'landscape-secondary': 180,
    'portrait-primary': 90,
    'portrait-secondary': 270,
};
/**
 * Compute the rotation (in degrees) required to correctly display a camera frame on iOS
 * devices based on the current screen orientation and camera lens used.
 *
 * The rotation compensates for both:
 * - The current screen orientation (`portrait` / `landscape`)
 * - The flipped view of the front-facing camera (adds a 180° correction in landscape)
 *
 * @param orientation - The current screen orientation containing `angle` and `type`.
 * @param frontCamera - Whether the active camera is the front-facing one.
 * @returns The clockwise rotation in degrees (effectively 0°, 90°, 180°, or 270°).
 */
export function getIosFrameRotation(orientation, frontCamera) {
    const rotation = orientationTypeToRotationMap[orientation.type];
    if (frontCamera &&
        (orientation.type === 'landscape-primary' ||
            orientation.type === 'landscape-secondary')) {
        /**
         * Frames coming from the front facing camera are upside down in landscape
         * mode on iOS. Flip them over by adding 180°.
         */
        return (rotation + 180) % 360;
    }
    return rotation;
}
